import { css } from 'styled-components';

export const bodySmall = css`
  font-size: 12px;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.textSecondary};
`;

export const body = css`
  font-size: 18px;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.textSecondary};
`;

export const title = css`
  font-size: 18px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.textPrimary};
`;

export const smallBoldTitle = css`
  font-size: 18px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.textPrimary};
`;

export const boldTitle = css`
  font-size: 18px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.textPrimary};
`;

export const largeTitle = css`
  font-size: 28px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.textPrimary};
`;

export const veryLargeTitle = css`
  font-size: 34px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.textPrimary};
`;

export const bodyPlaceholder = css`
  font-size: 16px;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.textPlaceholder};
`;

export const titlePlaceholder = css`
  font-size: 20px;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.textPlaceholder};
`;

export const button = css`
  font-size: 16px;
  font-weight: 600;
  font-family: ${({ theme }) => theme.fontFamily};
`;

export const textFieldValue = css`
  font-size: 18px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.textPrimary};
`;

export const verifyEmailText = css`
  font-size: 18px;
  font-weight: 500;
  color: #747474;
`;
